module.exports = __webpack_public_path__ + "files/1185f6ebf6c41be5c53527173cd7dc22.png";